import React from 'react';
import {
  format,
  subMonths,
  isSameMonth,
  lastDayOfMonth,
  differenceInCalendarMonths,
  isToday
} from 'date-fns';
import FormSelect from '../FormInput/FormSelect';

class BaseMonthSelector extends React.Component {
  onDateChange = (e, { value }) => {
    const val = value === 'all' ? null : value;
    this.props.onDateChange(val);
  };

  render() {
    const {
      className,
      selectedDate,
      displayFormat,
      currentDayText,
      earliestDate,
      latestDate,
      noFilterTitle
    } = this.props;

    let formattedEarliestDate = earliestDate;
    let formattedLatestDate = latestDate ? new Date(latestDate) : null;
    // if we got a latest date, make sure its a valid date
    formattedLatestDate =
      formattedLatestDate &&
      typeof formattedLatestDate.getTime === 'function' &&
      !!formattedLatestDate.getTime()
        ? formattedLatestDate
        : null;

    if (
      earliestDate &&
      typeof earliestDate === 'object' &&
      earliestDate.year &&
      (!!earliestDate.month || earliestDate.month === 0)
    ) {
      formattedEarliestDate = new Date(
        earliestDate.year,
        earliestDate.month - 1
      );
    }

    /**
     * if NO label is passed, default it to 'As of', however if we specifically
     * pass `false` as a label, then we specifically don't show it.
     * or if an actual label is passed, obviously show that
     */
    let { label } = this.props;
    label = typeof label === 'undefined' ? 'As of' : label;

    // when selectedDate comes back as null, set to 'all'
    const selected = !!selectedDate ? format(selectedDate, 'YYYY-MM-DD') : ( !!noFilterTitle ? 'all' : '' );

    return (
      <div className={`BaseMonthSelector date-selector ${className || ''}`}>
        {label && <label>{label}</label>}
        <MonthPicker
          placeholder="Please select a date"
          selectedDate={selected}
          onMonthChange={this.onDateChange}
          displayFormat={displayFormat}
          currentDayText={currentDayText}
          earliestDate={formattedEarliestDate}
          latestDate={formattedLatestDate}
          noFilterTitle={noFilterTitle}
        />
      </div>
    );
  }
}

const MonthPicker = ({
  placeholder,
  onMonthChange,
  selectedDate,
  displayFormat = 'MMMM YYYY',
  currentDayText,
  earliestDate,
  latestDate,
  noFilterTitle,
}) => {
  const startingMonth = latestDate || new Date();
  let optionCount = 12;
  if (earliestDate) {
    let diff = differenceInCalendarMonths(startingMonth, earliestDate);
    // if its only 1 month before, then add one so we can also show current month;
    optionCount = (!!diff || diff === 0) && !isNaN(diff) ? diff + 1 : 12;
    // we have to have at least 1 option.
    optionCount = optionCount > 0 ? optionCount : 1;
  }
  
  let months = [];
  let startIndex = 1;
  
  if (noFilterTitle) {
    startIndex = 2;
    months = [{ key: 0, text: noFilterTitle, value: 'all' }];
  }
  
  // if there is no latest date, then show "today"
  // or if there is a latest date, if it is today, then show "today"
  if (!latestDate || isToday(latestDate)) {
    months.push({
      key: startIndex - 1,
      text: currentDayText || 'Current Month',
      value: format(new Date(), 'YYYY-MM-DD')
    });
  } else {
    // if we did not add a "today", then we need to show whatever the latest date is for a partial month
    months.push({
      key: startIndex - 1,
      text: format(latestDate, displayFormat),
      value: format(latestDate, 'YYYY-MM-DD')
    });
  }
  
  for (let i = 1; i < optionCount; i++) {
    let month = subMonths(startingMonth, i);
    month = lastDayOfMonth(month);
    months.push({
      key: i + startIndex,
      text: format(month, displayFormat),
      value: format(month, 'YYYY-MM-DD')
    });
  }
  
  // if there is a latest date, and the selected date is the same month as the latest date, then the selected date is
  // the latest date, else its the last day of the month of the selected date
  let adjustedDate = selectedDate;
  let latest = latestDate || new Date();
  adjustedDate = isSameMonth(selectedDate, latest)
  ? latest : lastDayOfMonth(selectedDate);
  
  adjustedDate = format(adjustedDate, 'YYYY-MM-DD');
  return (
    <FormSelect
      options={months}
      onChange={onMonthChange}
      value={selectedDate === 'all' ? 'all' : adjustedDate}
    />
  );
};

export default BaseMonthSelector;
